// 封装门店信息请求
import request from '@/utils/request';
// import {getcpyNo} from '@/utils/auth';

// 门店列表
export function shopListApi(data) {
    return request({
        url: "/api/shop/list",
        method: "POST",
        params: data
    });
}
// 门店查看
export function shopSelectByIdApi(data){
    return request({
        url:"/api/shop/selectById",
        method:"get",
        params:data
    })
}
// 门店新新增
export function shopInsertApi(data){
    return request({
        url:"/api/shop/insert",
        method:"POST",
        params:data
    })
}
// 门店修改
export function shopUpdateApi(data){
    return request({
        url:"/api/shop/update",
        method:"POST",
        params:data
    })
}
// 门店删除
export function shopDeleteApi(data) {
    return request({
        url: "/api/shop/delete",
        method: "POST",
        params: data
    });
}
// 模糊门店查询
export function shopSelectByCodeApi(data){
    return request({
        url:"/api/shop/selectByCode",
        method:"GET",
        params:data
    })
}
// 查询区域
export function queryRegionApi(data) {
    return request({
        url: "/api/shop/queryRegion",
        method: "POST",
        params: data
    });
}
export function shopselectAppointTimeApi(data) {
    return request({
        url:"/api/shop/queryByAppointmentID",
        method:"post",
        params:data
    })
}
// 门店可预约时间管理---查看
export function selectAppointTimeApi(data) {
    return request({
        url: "/api/shop/selectAppointTime",
        method: "POST",
        params: data
    });
}
// 可预约时间管理--添加
export function insertAppointTimeApi(data) {
    return request({
        url: "/api/shop/insertAppointTime",
        method: "POST",
        params: data
    });
}
// 可预约时间管理--修改
export function updateAppointTimeApi(data) {
    return request({
        url: "/api/shop/updateAppointTime",
        method: "POST",
        params: data
    });
}
// 复制会员管理
export function selectCustcopymainApi(data) {
    return request({
        url: "/api/custcopymain/list",
        method: "POST",
        params: data
    });
}
// 复制会员
export function addCustcopymainApi(data) {
    return request({
        url: "/api/custcopymain/insert",
        method: "POST",
        params: data
    });
}
// 复制会员管理
export function exportCustcopymainApi(data) {
    return request({
        url: "/api/custcopymain/export",
        method: "POST",
        params: data
    });
}
//-------------------
// 改衣单列表
export function upDressPageApi(data){
    return request({
        url:"/api/cust/updress/page",
        method:"POST",
        params:data
    })
}
// 改衣单 查看
export function ChecktheclotheschangelistApi(data){
    return request({
        url:"api/cust/updress/query",
        method:"get",
        params:data
    })
}
// 获取改衣单号
export function ChangeorderNumberApi(data){
    return request({
        url:"api/cust/updress/getOrderNo",
        method:"GET",
        params:data
    })
}
// 改衣单 --- 创建弹窗选择销售单列表
export function SelectsalesorderlistApi(data){
    return request({
        url:"api/sale/selectSaleNo",
        method:"get",
        params:data
    })
}
//----------------
// 顾客维护记录---查看
export function maintainQueryApi(data){
    return request({
        url:"/api/cust/maintain/query",
        method:"GET",
        params:data
    })
}
// 添加
export function maintainInsertApi(data){
    return request({
        url:"/api/cust/maintain/insert",
        method:"POST",
        params:data
    })
}
// 顾客维护记录---修改
export function maintainUpdateApi(data){
    return request({
        url:"/api/cust/maintain/update",
        method:"POST",
        params:data
    })
}
// 删除
export function maintainDeleteApi(data){
    return request({
        url:"/api/cust/maintain/delete",
        method:"POST",
        params:data
    })
}
// 首页列表
export function maintainPageApi(data){
    return request({
        url:"/api/cust/maintain/page",
        method:"POST",
        params:data
    })
}
//维护主题 维护类型
export function definedqueryListApi(data){
    return request({
        url:"/api/user/defined/queryList",
        method:"get",
        params:data
    })
}
// 选择会员
export function selectCustListApi(data){
    return request({
        url:"/api/cust/selectCustList",
        method:"get",
        params:data
    })
}
// 维护人员
export function SysempselectEmpApi(data){
    return request({
        url:"/sys/emp/selectEmp",
        method:"get",
        params:data
    })
}
// 维护门店
export function shopSelectByCodewhApi(data){
    return request({
        url:"/api/shop/selectByCode",
        method:"get",
        params:data
    })
}
//------------------
//  Friends查询
export function sysConfigSetQueryApi(data){
    return request({
        url:"/api/gfriend/sysConfigSetQuery",
        method:"GET",
        params:data
    })
}
//  Friends修改
export function sysConfigSetInsertApi(data){
    return request({
        url:"/api/gfriend/sysConfigSetInsert",
        method:"POST",
        params:data
    })
}
//-------原因定义管理---------
// 原因定义列表
export function reasonListApi(data) {
    return request({
        url: "/api/reason/list",
        method: "POST",
        params: data
    })
}
// 原因类型
export const queryReasonKindDescApi=(data)=>{
    return request({
        url:"/api/reason/queryReasonKindDesc",
        method:"get",
        params:data
    })
}
// 原因查询
export function reasonSearchApi(data) {
    return request({
        url: "/api/reason/queryReasonByReasonID",
        method: "GET",
        params: data
    })
}
// 原因新增
export function reasonInsertApi(data) {
    return request({
        url: "/api/reason/insert",
        method: "post",
        data: data
    })
}
// 修改
export function reasonUpdateApi(data) {
    return request({
        url: "/api/reason/update",
        method: "POST",
        params: data
    })
}
//--------自定义元素--------
// 分页
export function definedPageApi(data){
    return request({
        url:"/api/user/defined/page",
        method:"get",
        params:data
    })
}
// 用户自定义元素分页
export function definedQueryApi(data){
    return request({
        url:"/api/user/defined/page",
        method:"get",
        params:data
    })
}
// 启用
export function enableApi(data){
    return request({
        url:"/api/user/defined/effect",
        method:"get",
        params:data
    })
}
// 禁用
export function disableApi(data){
    return request({
        url:"/api/user/defined/disable",
        method:"get",
        params:data
    })
}
// 创建
export function definedInsertApi(data){
    return request({
        url:"/api/user/defined/insert",
        method:"get",
        params:data
    })
}
// 修改
export function definedUpdateApi(data){
    return request({
        url:"/api/user/defined/update",
        method:'post',
        params:data
    })
}
// 自定义选项信息
export function defineDescPageApi(data) {
    return request({
        url: "/api/define/desc/page",
        method: "POST",
        params: data
    })
}

// 卡号变更
export  const custUpdateCardNoApi=(data)=>{
    return request({
        url:"/api/cust/updateCardNo",
        method:"post",
        data
    })
}
// 系统管理 -----------
// 用户管理
// 用户管理创建 ----门店模糊查询
export function shopselectListApi(data) {
    return request({
        url:"/api/shop/selectList",
        method:"GET",
        params:data
    })
}
// 用户管理 --- 数据权限
export function SysrolequeryRoleListApi(data) {
    return request({
        url:"/sys/role/queryRoleList",
        method:"GET",
        params:data
    })
}
// 用户管理 --- 获取菜单
export function SysmenugetMenusApi(data) {
    return request({
        url:"/sys/menu/getMenus",
        method:"GET",
        params:data
    })
}
